import React from "react";

export const BULAN = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
const pad = (n) => String(n).padStart(2, "0");

export function defaultPeriod() {
  const now = new Date();
  return { mode: "all", year: now.getFullYear(), month: now.getMonth() + 1 };
}

export function periodRange({ mode, year, month }) {
  if (mode === "year") return { date_from: `${year}-01-01`, date_to: `${year}-12-31` };
  if (mode === "month") {
    const last = new Date(year, month, 0).getDate();
    return { date_from: `${year}-${pad(month)}-01`, date_to: `${year}-${pad(month)}-${pad(last)}` };
  }
  return {};
}

export function fmtTanggal(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  return `${d} ${BULAN[m - 1]} ${y}`;
}

export function periodLabels(p, span = {}) {
  if (p.mode === "all") {
    const { first_date: f, last_date: l } = span;
    return f && l
      ? { flow: `Keseluruhan · ${fmtTanggal(f)} s.d. ${fmtTanggal(l)}`, asOf: `Per ${fmtTanggal(l)} (kumulatif seluruh transaksi)` }
      : { flow: "Keseluruhan", asOf: "Kumulatif seluruh transaksi" };
  }
  const { date_to } = periodRange(p);
  const flow = p.mode === "year" ? `Periode 1 Januari s.d. ${fmtTanggal(date_to)}` : `Periode 1 s.d. ${fmtTanggal(date_to)}`;
  return { flow, asOf: `Per ${fmtTanggal(date_to)}` };
}

const sel = "border border-slate-300 rounded-md px-3 py-2 text-sm bg-white";
const MODES = [["all", "Keseluruhan"], ["year", "Per Tahun"], ["month", "Per Bulan"]];

export function ReportPeriodFilter({ value, onChange, years }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="flex flex-wrap items-end gap-3 bg-white border border-slate-200 rounded-lg p-4" data-testid="report-period-filter">
      <div className="inline-flex rounded-md border border-slate-300 overflow-hidden" role="group">
        {MODES.map(([k, l]) => (
          <button key={k} type="button" onClick={() => set("mode", k)} data-testid={`period-mode-${k}`} disabled={k !== "all" && !years.length}
            className={`px-4 py-2 text-sm transition-colors ${value.mode === k ? "bg-slate-900 text-white" : "bg-white text-slate-700 hover:bg-slate-100"}`}>{l}</button>
        ))}
      </div>
      {value.mode !== "all" && (
        <select className={sel} value={value.year} onChange={(e) => set("year", Number(e.target.value))} data-testid="period-year-select">
          {years.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      )}
      {value.mode === "month" && (
        <select className={sel} value={value.month} onChange={(e) => set("month", Number(e.target.value))} data-testid="period-month-select">
          {BULAN.map((b, i) => <option key={b} value={i + 1}>{b}</option>)}
        </select>
      )}
    </div>
  );
}
